import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTranslatedText,
  getTranslatedTextSelector,
} from "../../../redux/slices/translatedText/getTranslatedText";

const TeacherIdProfileCard = ({
  teacherData,
  handleConfirmTeacherDetail,
  handleCancelTeacherDetail,
}) => {
  const teacher = teacherData?.[0];

  const dispatch = useDispatch();

  const getTextTranslated = useSelector(getTranslatedTextSelector);

  useEffect(() => {
    getText();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getText = async () => {
    await dispatch(getTranslatedText(localStorage.getItem("l_id"))).unwrap();
  };

  const getLabel = (pageKey, fallback) =>
    getTextTranslated?.data?.find((item) => item?.pageKey === pageKey)
      ?.keyValue || fallback;

  const teacherProfileData = [
    {
      label: getLabel("teacher_id", "Teacher ID"),
      value: teacher?.TeacherID,
    },
    {
      label: getLabel("teacher_name", "Teacher Name"),
      value: teacher?.TeacherName,
    },
    {
      label: getLabel("dob", "D.O.B"),
      value: teacher?.DOB,
    },
    {
      label: getLabel("gender", "Gender"),
      value: teacher?.GENDER,
    },
    {
      label: getLabel("mobile_number", "Mobile Number"),
      value: teacher?.MobileNumber,
    },
    {
      label: getLabel("whatsapp_number", "Whatsapp Number"),
      value: teacher?.WhatsappNumber || "-",
    },
    {
      label: getLabel("email_id", "Email ID"),
      value: teacher?.EmailId,
    },
    {
      label: getLabel("school_udise", "School UDISE"),
      value: teacher?.School_UDISE,
    },
    {
      label: getLabel("school_name", "School Name"),
      value: teacher?.SCHNAME,
    },
    {
      label: getLabel("state", "State"),
      value: teacher?.State,
    },
    {
      label: getLabel("district", "District"),
      value: teacher?.District,
    },
    {
      label: getLabel("block_zone", "Block/Zone"),
      value: teacher?.Block_Zone,
    },
    {
      label: getLabel("cluster_name", "Cluster Name"),
      value: teacher?.ClusterName,
    },
  ];

  return (
    <div className="flex flex-col h-[100vh] max-h-[100vh]">
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto bg-[#e9ebfa] p-4">
        <div className="w-full max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-12">
            {teacherProfileData &&
              teacherProfileData?.map((item) => (
                <div key={item.label}>
                  <p className="text-sm text-gray-400 mb-1">{item.label}</p>
                  <p className="text-base md:text-lg text-gray-900 font-medium break-words">
                    {item.value || "-"}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Fixed Footer */}
      <div className="sticky bottom-0 bg-white border-t p-4">
        <h2 className="text-center text-sm md:text-base font-medium mb-4">
          {getLabel(
            "confirm_once_again",
            "Please confirm the details once again",
          )}
        </h2>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            className="w-full sm:w-auto bg-[#E7EAFF] text-[#3C57AD] px-10 py-3 rounded-[10px]"
            onClick={handleCancelTeacherDetail}
          >
            {getLabel("not_txt", "No")}
          </button>

          <button
            className="w-full sm:w-auto bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-white px-10 py-3 rounded-[10px]"
            onClick={handleConfirmTeacherDetail}
          >
            {getLabel("yes_txt", "Yes")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherIdProfileCard;
